import getReimbursedFlow from "./getReimbursedFlow"
import cbpdReimbursementFlow from "./cbpdReimbursementFlow"
import { isCreditMember } from "#/components/views/molecules/subsidyCategoryGroups"
import { Subsidy } from "#/lib/carrot-api/types/Subsidy"

export enum ReimbursementWorkflows {
  PRIMARY = "Primary Workflow",
  CBPD = "CBPD Workflow"
}

export const reimbursementWorkflow = [
  {
    name: ReimbursementWorkflows.PRIMARY,
    workflow: getReimbursedFlow
  },
  {
    name: ReimbursementWorkflows.CBPD,
    workflow: cbpdReimbursementFlow
  }
]

// Carrot Card document uploads arrive with an expenseId and stay on the existing route.
export const isCbpdReimbursement = (expenseId: string | number | null, subsidies: Subsidy[] | null): boolean =>
  expenseId == null && isCreditMember(subsidies)
